/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: pms.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  GetPmsPatientPrefillRequest,
  GetPmsPatientPrefillResponse,
  SearchPmsPatientsRequest,
  SearchPmsPatientsResponse,
} from '../types/pms';

export const createPmsService = (transport: Transport) => ({
  async searchPmsPatients(
    request: SearchPmsPatientsRequest,
    options: RequestOptions = {},
  ): Promise<SearchPmsPatientsResponse> {
    const { organization_id, program_id, ...params } = request;
    const url = getApiPath(API_METHODS.PMSService.SearchPmsPatients, {
      organization_id,
      program_id,
    });
    return transport.get<SearchPmsPatientsResponse>(url, { params, ...options });
  },

  async getPmsPatientPrefill(
    request: GetPmsPatientPrefillRequest,
    options: RequestOptions = {},
  ): Promise<GetPmsPatientPrefillResponse> {
    const { organization_id, program_id, mfi, ...params } = request;
    const url = getApiPath(API_METHODS.PMSService.GetPmsPatientPrefill, {
      organization_id,
      program_id,
      mfi,
    });
    return transport.get<GetPmsPatientPrefillResponse>(url, { params, ...options });
  },
});

export type PmsService = ReturnType<typeof createPmsService>;
